import type { ReactNode } from 'react'

import { CssBaseline, ThemeProvider } from '@mui/material'

import { AuthProvider } from '../modules/auth/hooks/useAuth'
import { theme } from '../shared/theme/theme'

type AppProvidersProps = {
  children: ReactNode
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>{children}</AuthProvider>
    </ThemeProvider>
  )
}
